import { render, staticRenderFns } from "./Dothorizontal.vue?vue&type=template&id=ab12e840&scoped=true"
import script from "./Dothorizontal.vue?vue&type=script&lang=js"
export * from "./Dothorizontal.vue?vue&type=script&lang=js"
import style0 from "./Dothorizontal.vue?vue&type=style&index=0&id=ab12e840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab12e840",
  null
  
)

export default component.exports